import { EntitySwitch, isKind } from '@backstage/plugin-catalog';
import { componentPage } from './pages/ComponentPage';
import { apiPage } from './pages/ApiPage';
import { groupPage } from './pages/GroupPage';
import { userPage } from './pages/UserPage';
import { systemPage } from './pages/SystemPage';
import { domainPage } from './pages/DomainPage';
import { overviewTab, techdocsTab } from './shared/tabs';
import { EntityLayout } from '@backstage/plugin-catalog';

const defaultEntityPage = (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Resumo">{overviewTab}</EntityLayout.Route>
    <EntityLayout.Route path="/docs" title="Documentação">{techdocsTab}</EntityLayout.Route>
  </EntityLayout>
);

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')}>{componentPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('api')}>{apiPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('group')}>{groupPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('user')}>{userPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('system')}>{systemPage}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('domain')}>{domainPage}</EntitySwitch.Case>
    <EntitySwitch.Case>{defaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
